/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'

import * as ReferralCodeUpdate from '@root/entities/referral/model/referral-code-update'

import { reatomBufferEvents } from './reatom-buffer-events'

import type { tradeApi, chartApi } from '@blade/socket-types'
import type { TypeHelper } from '@blade/std-lib'
import type { Network } from '@root/entities/network/model'
import type { PairAddress } from '@root/entities/pair/model'
import type { TxHash } from '@root/entities/transaction/model/tx-hash'
import type BigNumber from 'bignumber.js'

export const pairUpdateEvent =
  action<tradeApi.PairUpdateData>('pairUpdateEvent')

export const pairUpdateNoBufferEvent = action<tradeApi.PairUpdateData>(
  'pairUpdateNoBufferEvent',
)

export const pairPartialUpdateEvent = action<tradeApi.PairPartialUpdateData>(
  'pairPartialUpdateEvent',
)

export const pairUpdateMigrationEvent =
  action<tradeApi.PairMigrationUpdateData>('pairUpdateMigrationEvent')

export const pairUpdateEventsBuffer = reatomBufferEvents({
  event: pairUpdateEvent,
  deriveKey: (data) => `${data.poolAddress}_${data.network}`,
})

export const referralCodeUpdateEvent = action(
  (_ctx, dto: ReferralCodeUpdate.ReferralCodeUpdateDto) =>
    ReferralCodeUpdate.fromDto(dto),
  'referralCodeUpdateEvent',
)

export const pairEventsEvent =
  action<tradeApi.PairEventsData>('pairEventsEvent')

export interface PairPriceUpdateData
  extends TypeHelper.OverrideKeys<
    tradeApi.PairPriceUpdateData,
    {
      pairAddress: PairAddress
      network: Network.Network
      priceNative: BigNumber
      priceUsd: BigNumber
      priceChangePercents: {
        '5M': BigNumber
        '1H': BigNumber
        '6H': BigNumber
        '1D': BigNumber
        ALL: BigNumber
      }
      updatedAt: Date
    }
  > {}

export const pairPriceUpdateEvent = action<PairPriceUpdateData>(
  'pairPriceUpdateEvent',
)

export const userPositionUpdateEvent = action<tradeApi.UserPositionData>(
  'userPositionUpdateRawEvent',
)

export const walletBalanceUpdateEvent = action<tradeApi.ITradeBotWallet>(
  'walletBalanceUpdateEvent',
)

export const userOrderEvent = action<tradeApi.UserOrderData>('userOrderEvent')

export type ConfirmTransactionUpdatePayload = TypeHelper.OverrideKeys<
  Parameters<
    tradeApi.ServerToClientEvents[tradeApi.ServerEvent.ConfirmTransactionUpdate]
  >[0],
  {
    txHash: TxHash
  }
>

export const confirmTransactionUpdateEvent =
  action<ConfirmTransactionUpdatePayload>('confirmTransactionUpdateEvent')

export const poolActivityEvent =
  action<tradeApi.PoolActivity>('poolActivityEvent')

export const blockHashEvent = action<chartApi.BlockhashData>('blockHashEvent')

export const supportTicketUpdatedEvent = action<tradeApi.SupportTicketData>(
  'supportTicketUpdatedEvent',
)

export const supportMessageCreatedEvent = action<tradeApi.SupportMessageData>(
  'supportMessageCreatedEvent',
)
